import {
    ableProps,
    ablePropsInit,
    requiredProps,
    requiredPropsInit,
    events as baseEvents,
} from '../component-base/props';
import { getFormConfig } from '../../config';
export const props = () => [
    ...ableProps,
    ...requiredProps,
    {
        key: 'hideTitle',
        label: '是否隐藏标题文字',
        type: 'boolean',
    },
    {
        key: 'hint',
        label: '提示文字',
        type: 'string',
    },
    {
        key: 'errUpload',
        label: '上传错误提示文案',
        type: 'string',
    },
    {
        key: 'errNetwork',
        label: '网络错误默认提示',
        type: 'string',
    },
    {
        key: 'tipRetry',
        label: '重试按钮文案',
        type: 'string',
    },
    {
        key: 'autoUpload',
        label: '选中文件后立即上传',
        type: 'boolean',
    },
    {
        key: 'action',
        label: '上传地址',
        type: 'string',
    },
    {
        key: 'accept',
        label: '格式限制',
        type: 'string',
        props: {
            placeholder: '如 image/* ,留空代表不限制',
        },
    },
    {
        // 约定0为不处理
        key: 'maxSize',
        label: '大小限制(kb)',
        type: 'number',
        props: {
            controls: false,
        },
    },
    {
        key: 'errSizeExceed',
        label: '大小超限提示',
        type: 'string',
    },
    {
        key: 'fileName',
        label: '上传时字段名',
        type: 'string',
        props: {
            placeholder: '上传文件时文件的name属性',
        },
    },
    {
        key: 'pickKey',
        label: '保留哪个返回值',
        type: 'string',
        props: {
            placeholder: '留空代表保留所有返回值',
        },
    },
    {
        key: 'previewSrc',
        label: '预览地址',
        type: 'string',
        props: {
            placeholder: '如 /a/b/c?id={file} 替换{file}为文件id',
        },
    },
    {
        key: 'sampleImageSrc',
        label: '示例图地址',
        type: 'string',
        props: {
            placeholder: '不填表示无示例图',
        },
    },
];

export const init = () => {
    const formConfig = getFormConfig();
    return {
        ...ablePropsInit,
        ...requiredPropsInit,
        hideTitle: true,
        hint: '',
        errUpload: '上传失败',
        errNetwork: '网络错误',
        tipRetry: '点击重试',
        autoUpload: true,
        action: formConfig.uploadActionSrc,
        accept: '',
        maxSize: 0,
        errSizeExceed: '',
        fileName: 'file',
        pickKey: 'key',
        previewSrc: formConfig.uploadPreviewSrc,
        sampleImageSrc: '',
    };
};

export const name = '单个文件上传';

export const component = 'mobile-general-form-single-upload';

export const events = [
    'upload-success',
    'upload-clear',
    'change',
    ...baseEvents,
];

